import '../../i18n/autoTranslate';
import React, { useState, useEffect } from "react";
import { Camera, CheckCircle, Globe } from "lucide-react";
import { useSelector } from "react-redux";
import { Button } from "../../../components/ui/shadcn/button";
import { Input } from "../../../components/ui/shadcn/input";
import { Label } from "../../../components/ui/shadcn/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "../../../components/ui/shadcn/select";

// Import country flags
import US from 'country-flag-icons/react/3x2/US';
import DE from 'country-flag-icons/react/3x2/DE';
import JP from 'country-flag-icons/react/3x2/JP';
import BR from 'country-flag-icons/react/3x2/BR';
import CA from 'country-flag-icons/react/3x2/CA';
import GB from 'country-flag-icons/react/3x2/GB';
import FR from 'country-flag-icons/react/3x2/FR';
import AU from 'country-flag-icons/react/3x2/AU';
import IN from 'country-flag-icons/react/3x2/IN';
import CN from 'country-flag-icons/react/3x2/CN';
import SG from 'country-flag-icons/react/3x2/SG';
import AE from 'country-flag-icons/react/3x2/AE';
import IT from 'country-flag-icons/react/3x2/IT';
import ES from 'country-flag-icons/react/3x2/ES';
import NL from 'country-flag-icons/react/3x2/NL';
import SE from 'country-flag-icons/react/3x2/SE';
import NO from 'country-flag-icons/react/3x2/NO';
import DK from 'country-flag-icons/react/3x2/DK';
import FI from 'country-flag-icons/react/3x2/FI';
import BE from 'country-flag-icons/react/3x2/BE';
import CH from 'country-flag-icons/react/3x2/CH';
import AT from 'country-flag-icons/react/3x2/AT';
import PT from 'country-flag-icons/react/3x2/PT';
import IE from 'country-flag-icons/react/3x2/IE';
import PL from 'country-flag-icons/react/3x2/PL';
import CZ from 'country-flag-icons/react/3x2/CZ';
import HU from 'country-flag-icons/react/3x2/HU';
import RO from 'country-flag-icons/react/3x2/RO';
import GR from 'country-flag-icons/react/3x2/GR';
import TR from 'country-flag-icons/react/3x2/TR';
import RU from 'country-flag-icons/react/3x2/RU';
import UA from 'country-flag-icons/react/3x2/UA';
import KR from 'country-flag-icons/react/3x2/KR';
import MX from 'country-flag-icons/react/3x2/MX';
import AR from 'country-flag-icons/react/3x2/AR';
import CL from 'country-flag-icons/react/3x2/CL';
import CO from 'country-flag-icons/react/3x2/CO';
import PE from 'country-flag-icons/react/3x2/PE';
import ZA from 'country-flag-icons/react/3x2/ZA';
import NG from 'country-flag-icons/react/3x2/NG';
import EG from 'country-flag-icons/react/3x2/EG';
import SA from 'country-flag-icons/react/3x2/SA';
import TH from 'country-flag-icons/react/3x2/TH';
import ID from 'country-flag-icons/react/3x2/ID';
import MY from 'country-flag-icons/react/3x2/MY';
import PH from 'country-flag-icons/react/3x2/PH';
import VN from 'country-flag-icons/react/3x2/VN';

// Country data with flags
const countries = [
  { value: "US", label: "United States", flag: <US className="w-5 h-4" /> },
  { value: "DE", label: "Germany", flag: <DE className="w-5 h-4" /> },
  { value: "JP", label: "Japan", flag: <JP className="w-5 h-4" /> },
  { value: "BR", label: "Brazil", flag: <BR className="w-5 h-4" /> },
  { value: "CA", label: "Canada", flag: <CA className="w-5 h-4" /> },
  { value: "GB", label: "United Kingdom", flag: <GB className="w-5 h-4" /> },
  { value: "FR", label: "France", flag: <FR className="w-5 h-4" /> },
  { value: "AU", label: "Australia", flag: <AU className="w-5 h-4" /> },
  { value: "IN", label: "India", flag: <IN className="w-5 h-4" /> },
  { value: "CN", label: "China", flag: <CN className="w-5 h-4" /> },
  { value: "SG", label: "Singapore", flag: <SG className="w-5 h-4" /> },
  { value: "AE", label: "United Arab Emirates", flag: <AE className="w-5 h-4" /> },
  { value: "IT", label: "Italy", flag: <IT className="w-5 h-4" /> },
  { value: "ES", label: "Spain", flag: <ES className="w-5 h-4" /> },
  { value: "NL", label: "Netherlands", flag: <NL className="w-5 h-4" /> },
  { value: "SE", label: "Sweden", flag: <SE className="w-5 h-4" /> },
  { value: "NO", label: "Norway", flag: <NO className="w-5 h-4" /> },
  { value: "DK", label: "Denmark", flag: <DK className="w-5 h-4" /> },
  { value: "FI", label: "Finland", flag: <FI className="w-5 h-4" /> },
  { value: "BE", label: "Belgium", flag: <BE className="w-5 h-4" /> },
  { value: "CH", label: "Switzerland", flag: <CH className="w-5 h-4" /> },
  { value: "AT", label: "Austria", flag: <AT className="w-5 h-4" /> },
  { value: "PT", label: "Portugal", flag: <PT className="w-5 h-4" /> },
  { value: "IE", label: "Ireland", flag: <IE className="w-5 h-4" /> },
  { value: "PL", label: "Poland", flag: <PL className="w-5 h-4" /> },
  { value: "CZ", label: "Czech Republic", flag: <CZ className="w-5 h-4" /> },
  { value: "HU", label: "Hungary", flag: <HU className="w-5 h-4" /> },
  { value: "RO", label: "Romania", flag: <RO className="w-5 h-4" /> },
  { value: "GR", label: "Greece", flag: <GR className="w-5 h-4" /> },
  { value: "TR", label: "Turkey", flag: <TR className="w-5 h-4" /> },
  { value: "RU", label: "Russia", flag: <RU className="w-5 h-4" /> },
  { value: "UA", label: "Ukraine", flag: <UA className="w-5 h-4" /> },
  { value: "KR", label: "South Korea", flag: <KR className="w-5 h-4" /> },
  { value: "MX", label: "Mexico", flag: <MX className="w-5 h-4" /> },
  { value: "AR", label: "Argentina", flag: <AR className="w-5 h-4" /> },
  { value: "CL", label: "Chile", flag: <CL className="w-5 h-4" /> },
  { value: "CO", label: "Colombia", flag: <CO className="w-5 h-4" /> },
  { value: "PE", label: "Peru", flag: <PE className="w-5 h-4" /> },
  { value: "ZA", label: "South Africa", flag: <ZA className="w-5 h-4" /> },
  { value: "NG", label: "Nigeria", flag: <NG className="w-5 h-4" /> },
  { value: "EG", label: "Egypt", flag: <EG className="w-5 h-4" /> },
  { value: "SA", label: "Saudi Arabia", flag: <SA className="w-5 h-4" /> },
  { value: "TH", label: "Thailand", flag: <TH className="w-5 h-4" /> },
  { value: "ID", label: "Indonesia", flag: <ID className="w-5 h-4" /> },
  { value: "MY", label: "Malaysia", flag: <MY className="w-5 h-4" /> },
  { value: "PH", label: "Philippines", flag: <PH className="w-5 h-4" /> },
  { value: "VN", label: "Vietnam", flag: <VN className="w-5 h-4" /> },
];

export default function ProfileSettings({ embedded = false } = {}) {
  const [profileData, setProfileData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    country: "",
    photo: null,
    resume_data: {},
  });

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const {user, accessToken, refreshToken, isAuthenticated, error} = useSelector((state) => state.auth);

  // Load user data on component mount
  useEffect(() => {
    const loadUserData = async () => {
      setLoading(true);
      try {
        if (user) {
          const mockUserData = {
            first_name: user?.first_name || "",
            last_name: user?.last_name || "",
            email: user?.email || "",
            phone_number: user?.phone_number || "+1-555-0123",
            country: user?.country || "US",
            resume_data: user?.resume_data || {},
          };
          setProfileData(mockUserData);
        }
      } catch (error) {
        console.error("Failed to load user data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadUserData();
  }, [user]);

  const handleInputChange = (name, value) => {
    setProfileData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setProfileData((prev) => ({ ...prev, photo: event.target.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      // Replace with actual API call
      // await updateUserProfile(profileData);
      console.log("Profile saved:", profileData);
      alert("Profile updated successfully!");
    } catch (error) {
      console.error("Failed to save profile:", error);
      alert("Failed to update profile. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {!embedded && (
        <>
          <h2 className="text-2xl font-semibold tracking-tight text-white">Profile Settings</h2>
          <p className="text-gray-200/70 text-sm sm:text-base">Update your personal information below.</p>
        </>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Profile Picture */}
        <div className="flex flex-col items-center space-y-4">
          {profileData.photo ? (
            <img
              src={profileData.photo}
              alt="Profile"
              className="rounded-full w-20 h-20 sm:w-24 sm:h-24 object-cover border-2 border-indigo-500"
            />
          ) : (
            <div className="rounded-full w-20 h-20 sm:w-24 sm:h-24 bg-white/5 flex items-center justify-center border border-white/10">
              <Camera className="h-8 w-8 text-gray-400" />
            </div>
          )}

          <div className="w-full space-y-2">
            <Label className="text-gray-200/80">Profile Picture</Label>
            <Input type="file" accept="image/*" onChange={handlePhotoUpload} className="text-white" />
          </div>
        </div>

        {/* Name Fields */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label className="text-gray-200/80">First Name</Label>
            <Input
              name="first_name"
              value={profileData.first_name}
              onChange={(e) => handleInputChange("first_name", e.target.value)}
              placeholder="Enter your first name"
              className="text-white"
              required
            />
          </div>

          <div className="space-y-2">
            <Label className="text-gray-200/80">Last Name</Label>
            <Input
              name="last_name"
              value={profileData.last_name}
              onChange={(e) => handleInputChange("last_name", e.target.value)}
              placeholder="Enter your last name"
              className="text-white"
              required
            />
          </div>
        </div>

        {/* Email */}
        <div className="space-y-2">
          <Label className="text-gray-200/80">Email</Label>
          <Input
            type="email"
            name="email"
            value={profileData.email}
            onChange={(e) => handleInputChange("email", e.target.value)}
            placeholder="your.email@example.com"
            className="text-white"
            required
          />
        </div>

        {/* Phone */}
        <div className="space-y-2">
          <Label className="text-gray-200/80">Phone Number</Label>
          <Input
            type="tel"
            name="phone_number"
            value={profileData.phone_number}
            onChange={(e) => handleInputChange("phone_number", e.target.value)}
            placeholder="+1-555-0123"
            className="text-white"
            required
          />
        </div>

        {/* Country Selection */}
        <div className="space-y-4">
          <div className="space-y-2">
            <Label className="text-gray-200/80">Country</Label>
            <Select value={profileData.country} onValueChange={(v) => handleInputChange("country", v)}>
              <SelectTrigger className="w-full text-white">
                <SelectValue placeholder="Select your country" />
              </SelectTrigger>
              <SelectContent className="bg-[#0B0B12] border-white/10 text-white">
                {countries.map((c) => (
                  <SelectItem key={c.value} value={c.value}>
                    <span className="flex items-center gap-2">
                      {c.flag}
                      <span>{c.label}</span>
                    </span>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {profileData.country && (
            <div className="bg-white/5 border border-white/10 rounded-xl p-4">
              <div className="flex items-center space-x-2 mb-2">
                <Globe className="h-5 w-5 text-indigo-400" />
                <h3 className="font-semibold text-white">
                  Country Selected: {countries.find(c => c.value === profileData.country)?.label}
                </h3>
              </div>
              <p className="text-sm text-gray-200/70">
                Your resume will be formatted according to {countries.find(c => c.value === profileData.country)?.label} standards.
              </p>
            </div>
          )}
        </div>

        {/* Save Button */}
        <Button
          type="submit"
          disabled={saving}
          className="w-full h-11 mt-2 bg-gradient-to-br from-[#8B7CFF] to-[#6C63FF] text-white hover:shadow-[0_0_50px_rgba(108,99,255,0.35)]"
        >
          <CheckCircle className="h-4 w-4" />
          {saving ? "Saving..." : "Save Profile"}
        </Button>
      </form>
    </div>
  );
}
